import axios from 'axios';
import * as endpoints from './const';

class AdminApi {
  static getUser(id) {
    return axios
      .get(`${endpoints.USERS}/${id}`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getUserRoles(id) {
    return axios
      .get(`${endpoints.ADMIN}/users/${id}/roles`)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static updateUser(userModel) {
    return axios
      .post(`${endpoints.ADMIN}/users`, {
        ...userModel
      })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  static getSampleFile() {
    axios({
      url: `${endpoints.USERS_ADMIN}/sampleBulkImportFile`,
      method: 'GET',
      responseType: 'blob'
    }).then(response => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'SampleNitroUserImport.csv');
      document.body.appendChild(link);
      link.click();
    });
  }

  static saveBulkUserData(bulkUserUpload) {
    const data = new FormData();
    data.set('file', bulkUserUpload.File[0], bulkUserUpload.File[0].name);
    data.set('businessEntityId', bulkUserUpload.businessEntityId);
    data.set('countryCode', bulkUserUpload.countryCode);
    data.set('roleId', bulkUserUpload.roleId);
    data.set('zoneId', bulkUserUpload.zoneId);
    return axios({
      method: 'post',
      url: `${endpoints.USERS_ADMIN}/uploadUsers`,
      data,
      config: { headers: { 'Content-Type': 'multipart/form-data' } }
    })
      .then(response => response.data)
      .catch(error => {
        throw error;
      });
  }

  static getUserRestrictions(id) {
    return axios
      .get(`${endpoints.USERS_ADMIN}/${id}/restrictions`)
      .then(response => response.data)
      .then(data => data.data.companyCodes)
      .catch(error => {
        throw error;
      });
  }

  static getRestriction(businessEntityId, countryCode, companyCode) {
    const api = endpoints.ALL_RESTRICTIONS_ADMIN.replace(
      ':businessEntityId',
      businessEntityId
    )
      .replace(':country', countryCode)
      .replace(':companycode', companyCode);

    return axios
      .get(api)
      .then(data => data.data.data)
      .catch(error => {
        throw error;
      });
  }

  static getCompanyCodes(businessEntityId, companyCode, lookup) {
    return axios
      .get(
        `${endpoints.BUSINESS_ENTITIES_ADMIN}/companycodes/${businessEntityId}/${companyCode}?lookup=${lookup}`
      )
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getAllRoles(businessEntityId, countryCode) {
    return axios
      .get(
        `${endpoints.ROLES_ADMIN}?businessEntityId=${businessEntityId}&countryCode=${countryCode}`
      )
      .then(response => response.data.data)
      .catch(error => {
        throw error;
      });
  }
  static getBusinessEntities() {
    return axios
      .get(endpoints.BUSINESS_ENTITIES_ADMIN)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getClaims() {
    return axios
      .get(endpoints.BUSINESS_ENTITIES_ADMIN_CLAIMS)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getEmployer(businessEntityId, countryCode, searchText) {
    return axios
      .get(
        `${endpoints.BUSINESS_ENTITIES_ADMIN
        }/${businessEntityId}/${countryCode}/employers?companyCodeLookup=${encodeURIComponent(
          searchText
        ) || ''}`
      )
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static getCompanyHierarchy(businessEntityId, countryCode, companyCode) {
    const apiUrl = `${endpoints.COMPANY_HIERARCHY}?companyCode=${encodeURIComponent(companyCode)}`.replace(
      ':businessEntityId',
      businessEntityId
    )
      .replace(':countryCode', countryCode);

    return axios
      .get(apiUrl)
      .then(response => response.data)
      .then(data => data.data)
      .catch(error => {
        throw error;
      });
  }

  static bulkTerminate(ids) {
    return axios
      .post(`${endpoints.ADMIN}/users/terminate`, ids)
      .then(response => response)
      .catch(error => {
        throw error;
      });
  }

  static bulkReactivate(ids) {
    return axios
      .post(`${endpoints.ADMIN}/users/reactivate`, ids)
      .then(response => response)
      .catch(error => {
        throw error;
      });
  }

  static bulkUnlock(ids) {
    return axios
      .post(`${endpoints.ADMIN}/users/unlock`, ids)
      .then(response => response)
      .then(data => data)
      .catch(error => {
        throw error;
      });
  }

  static bulkLock(ids) {
    return axios
      .post(`${endpoints.ADMIN}/users/lock`, ids)
      .then(response => response)
      .catch(error => {
        throw error;
      });
  }
  static setPassword(userId, newPassword) {
    return axios
      .post(`${endpoints.ADMIN}/users/setPassword`, {
        userId,
        newpassword: newPassword
      })
      .then(response => response.data)
      .then(data => {
        const { success, errors } = data;
        return {
          success,
          error: errors[0]
        };
      })
      .catch(error => {
        throw error;
      });
  }
}

export default AdminApi;



// WEBPACK FOOTER //
// ./src/api/AdminApi.js